import { AccessDeniedError } from "../../domain/errors";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { InventoryReservation } from "../../domain/models/inventory-reservation";
import { SeparateReservation } from "../../domain/usecases/separate-reservation";
import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbSeparateReservation implements SeparateReservation {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}
  async separate(reservation: InventoryReservation): Promise<boolean> {
    const res = await this.httpClient.request({
      url: this.url,
      method: "post",
      body: reservation,
    });
    switch (res.statusCode) {
      case HttpStatusCode.ok:
        return true;
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError();
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();
      default:
        return false;
    }
  }
}
